import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';  // <-- añade useParams
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import axios from 'axiosInstance';
import '../css/AuthLogin.css'; 

export default function ResetPassword() {
  const { token } = useParams(); 
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const decodedToken = decodeURIComponent(token);  

    try {
      await axios.post(process.env.REACT_APP_BACKEND_URL + `/api/auth/reset-password/${decodedToken}`, {
  password,
});

      setStatus('success');
      setMessage('✅ ¡Tu contraseña ha sido actualizada correctamente!');
      setTimeout(() => navigate('/login'), 1000);
    } catch (err) {
      if (err.response?.status === 401) {
        setStatus('error');
        setMessage('❌ El token es inválido o ha expirado.');
      } else {
        setStatus('error');
        setMessage('❌ Ha ocurrido un error inesperado al actualizar la contraseña.');
      }
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h3 className="Titulo">Recuperar Contraseña</h3>

          {status && (
            <Alert variant={status === 'success' ? 'success' : 'danger'}>
              {message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formNewPassword" className="mb-3">
              <Form.Label>Nueva contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Introduce tu nueva contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button  type="submit" className="boton_accion_user w-100">
              Cambiar contraseña
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
